// Sessions panel — Phase 1 stub. Wires up properly in Phase 3 once the
// brainstorm `observations-store` is exposed via `@cogo/kg-repository`
// (the existing localStorage store is the Phase 1 source of truth; this
// stub documents the plan without pulling in a new dep yet).

import { useStudioLocale } from '@/i18n'

export function SessionsPanel() {
  const { strings } = useStudioLocale()
  const copy = strings.appMap.sessions
  return (
    <section className="px-3 py-3" aria-labelledby="sessions-heading">
      <h3 id="sessions-heading" className="mb-2 text-xs font-semibold uppercase tracking-wider text-muted-foreground">
        {copy.title}
      </h3>
      <p className="text-xs leading-5 text-muted-foreground">{copy.body}</p>
    </section>
  )
}
